document.addEventListener("DOMContentLoaded", function(){
    window.onscroll = function() {
        var topBar = document.getElementById('product-topbar');
        var sticky = topBar.offsetTop;

        if (window.pageYOffset > sticky) {
            topBar.classList.add("sticky");
        } else {
            topBar.classList.remove("sticky");
        }
    };
});

var elementsToRemove = document.querySelectorAll("li.buddha-disabled");

for (var i = 0; i < elementsToRemove.length; i++) {
  var element = elementsToRemove[i];
  element.parentNode.removeChild(element);
}
